import { styled } from '@linaria/react';
import { themeCssVariables } from 'app-ui/theme';

import { LoadingState } from '@/ui/feedback/loading-state/components/LoadingState';

const StyledScreen = styled.div`
  background: ${themeCssVariables.background.primary};
  display: flex;
  flex: 1;
  flex-direction: column;
`;

// For gates that show before any page (sign-in, session, workspace switch).
export const FullScreenLoadingState = () => (
  <StyledScreen>
    <LoadingState />
  </StyledScreen>
);
